import { useState, useEffect } from "react";
import logger from "../../../util/logger";

import Swal from "sweetalert2";

import classnames from "classnames";

import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
// import { MdNewReleases } from "react-icons/md";

import { useTranslation } from "react-i18next";

function ChallengesPage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // eslint-disable-next-line
  const [challenges, setChallenges] = useState();
  const [activeChallenges, setActiveChallenges] = useState();
  // const [requestedChallenges, setRequestedChallenges] = useState();
  const [closedChallenges, setClosedChallenges] = useState();
  const fetchChallenges = async () => {
    try {
      setIsLoading(true);

      // let fetchedChallenges = [];
      let fetchedActiveChallenges = [];
      // let fetchedRequestedChallenges = [];
      let fetchedClosedChallenges = [];

      const q = query(
        collection(db, "rooms"),
        where("memberUids", "array-contains", user.uid)
      );
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newRoom = doc.data();
        if (newRoom.challenges) {
          newRoom.challenges.forEach((challenge) => {
            let newChallengeObject = challenge;
            if (challenge.bets.some((bet) => bet.bettorUid === user.uid)) {
              newChallengeObject.sport = newRoom.leagueSport;
              newChallengeObject.league = newRoom.leagueName;
              newChallengeObject.roomUid = newRoom.uid;

              if (challenge.isCompleted) {
                if (!newRoom.isActive) {
                  newChallengeObject.isExpired = true;
                }
                fetchedClosedChallenges.push(newChallengeObject);
              } else {
                if (newRoom.isActive) {
                  fetchedActiveChallenges.push(newChallengeObject);
                }
              }
            }
          });
        }
      });

      // setChallenges(fetchedChallenges);
      setActiveChallenges(fetchedActiveChallenges);
      // setRequestedChallenges(fetchedRequestedChallenges);
      setClosedChallenges(fetchedClosedChallenges);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert(t("errorFetchingChallenges"));
    }
  };

  useEffect(() => {
    if (user) {
      fetchChallenges();
    }
    // eslint-disable-next-line
  }, [user]);

  const [activeTab, setActiveTab] = useState("ACTIVE");
  const toggleActiveTab = (tab) => {
    setActiveTab(tab);
  };

  const cancelChallenge = async (challenge) => {
    Swal.fire({
      text: t("areYouSureYouWantToCancelThisChallenge"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: t("yesImSure"),
      cancelButtonText: t("noCancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const q = query(
            collection(db, "rooms"),
            where("uid", "==", challenge.roomUid)
          );
          const docs = await getDocs(q);
          docs?.forEach(async (room) => {
            const newRoom = room.data();
            const getRoom = doc(db, "rooms", room.id);

            let newChallenges = [...newRoom.challenges];

            newChallenges = newChallenges.filter(
              (e) => e.uid !== challenge.uid
            );

            await updateDoc(getRoom, {
              challenges: newChallenges,
            });
          });

          const bettors = [];

          challenge.bets.forEach((bet) => {
            bettors.push(bet.bettorUid);
          });

          bettors.forEach(async (bettor) => {
            const q1 = query(
              collection(db, "users"),
              where("uid", "==", bettor)
            );
            const docs1 = await getDocs(q1);
            docs1?.forEach(async (userObject) => {
              const newUser = userObject.data();
              const getUser = doc(db, "users", userObject.id);
              let newStarCoins = newUser.starCoins;

              newStarCoins += parseInt(challenge.starCoins);

              await updateDoc(getUser, {
                starCoins: newStarCoins,
              });
            });
          });

          Swal.fire({
            text: t("challengeCancelled"),
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: t("ok"),
          });

          fetchChallenges();
          // fetchRoom();
          // setResultForChallenge();
          // setBetForChallenge();
          // toggleChallengeModal();
          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert(err.message);

          setIsLoading(false);
        }
      }
    });
  };

  const claimStarCoins = async (challenge) => {
    Swal.fire({
      text: t("areYouSureYouWantToClaimYourRewardInStarCoins"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: t("yesImSure"),
      cancelButtonText: t("noCancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        logger.debug(challenge);
        try {
          setIsLoading(true);

          const q = query(
            collection(db, "users"),
            where("uid", "==", user.uid)
          );
          const docs = await getDocs(q);
          docs?.forEach(async (userObject) => {
            const newUser = userObject.data();
            const getUser = doc(db, "users", userObject.id);
            let newStarCoins = newUser.starCoins;

            newStarCoins += parseInt(challenge.prizePool);

            await updateDoc(getUser, {
              starCoins: newStarCoins,
            });
          });

          const q1 = query(
            collection(db, "rooms"),
            where("uid", "==", challenge.roomUid)
          );
          const docs1 = await getDocs(q1);
          docs1?.forEach(async (room) => {
            const newRoom = room.data();
            const getRoom = doc(db, "rooms", room.id);

            let newChallenges = [...newRoom.challenges];

            newChallenges.forEach((e) => {
              if (e.uid === challenge.uid) {
                e.isRewardClaimed = true;
              }
            });

            await updateDoc(getRoom, {
              challenges: newChallenges,
            });
          });

          Swal.fire({
            text: t("starCoinsClaimed"),
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: t("ok"),
          });

          fetchChallenges();

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert(err.message);

          setIsLoading(false);
        }
      }
    });
  };

  const claimTickets = async (challenge) => {
    Swal.fire({
      text: t("areYouSureYouWantToClaimYourRewardInTickets"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: t("yesImSure"),
      cancelButtonText: t("noCancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const q = query(
            collection(db, "users"),
            where("uid", "==", user.uid)
          );
          const docs = await getDocs(q);
          docs?.forEach(async (userObject) => {
            const newUser = userObject.data();
            const getUser = doc(db, "users", userObject.id);
            let newTickets = newUser.tickets;

            const starCoinsInTickets = parseInt(challenge.prizePool) / 10;
            newTickets += starCoinsInTickets;

            await updateDoc(getUser, {
              tickets: newTickets,
            });
          });

          const q1 = query(
            collection(db, "rooms"),
            where("uid", "==", challenge.roomUid)
          );
          const docs1 = await getDocs(q1);
          docs1?.forEach(async (room) => {
            const newRoom = room.data();
            const getRoom = doc(db, "rooms", room.id);

            let newChallenges = [...newRoom.challenges];

            newChallenges.forEach((e) => {
              if (e.uid === challenge.uid) {
                e.isRewardClaimed = true;
              }
            });

            await updateDoc(getRoom, {
              challenges: newChallenges,
            });
          });

          Swal.fire({
            text: t("ticketsClaimed"),
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: t("ok"),
          });

          fetchChallenges();

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert(err.message);

          setIsLoading(false);
        }
      }
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="notificationsPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("challenges").toUpperCase()}
      </h1>
      <div>
        <ScrollMenu>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeTab === "ACTIVE",
            })}
            onClick={() => toggleActiveTab("ACTIVE")}
          >
            <p>{t("active").toUpperCase()}</p>
          </div>
          {/* <div className={classnames('shopCategoriesMenuItem',{active: (activeTab === 'REQUESTS')})} onClick={() => toggleActiveTab('REQUESTS')}>
            <p>
              {t('requests').toUpperCase()}
            </p>
          </div> */}
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeTab === "HISTORY",
            })}
            onClick={() => toggleActiveTab("HISTORY")}
          >
            <p>{t("history").toUpperCase()}</p>
          </div>
        </ScrollMenu>
        <div style={{ marginTop: "1rem" }}>
          {activeTab === "ACTIVE" ? (
            <div className="adminPageSection">
              {activeChallenges?.length > 0 ? (
                activeChallenges.map((challenge) => {
                  return (
                    <div>
                      <div
                        className="eventChallengeCard"
                        style={{
                          color: "#FFFFFF",
                          cursor: "default",
                          textAlign: "center",
                        }}
                      >
                        <p>
                          <div className="challengeEventDetails">
                            <p style={{ fontSize: "14px" }}>
                              {challenge.sport} - {challenge.league}
                            </p>
                            <div className="challengeEventTeams">
                              <div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontFamily: "Oswald",
                                  }}
                                >
                                  {t("home").toUpperCase()}
                                </p>
                                <p>{challenge.event.homeTeam.toUpperCase()}</p>
                              </div>
                              <p
                                style={{
                                  marginLeft: "1rem",
                                  marginRight: "1rem",
                                  fontWeight: "bold",
                                  color: "#FABB00",
                                }}
                              >
                                {t("vs").toUpperCase()}
                              </p>
                              <div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontFamily: "Oswald",
                                  }}
                                >
                                  {t("away").toUpperCase()}
                                </p>
                                <p>{challenge.event.awayTeam.toUpperCase()}</p>
                              </div>
                            </div>
                          </div>
                          <span
                            className="eventChallengeSubmitterName"
                            style={{ color: "#FABB00" }}
                          >
                            {challenge?.submitterUid !== user?.uid
                              ? challenge.submitterName
                              : t("you")}
                          </span>{" "}
                          {challenge?.submitterUid !== user?.uid
                            ? t("has")
                            : t("have")}{" "}
                          <span className="eventChallengeTickets">
                            {challenge.starCoins}
                          </span>{" "}
                          {t("starCoins")} {t("on")}{" "}
                          <span className="eventChallengeResult">
                            {t(
                              challenge.result?.toLowerCase() || "result"
                            ).toUpperCase()}
                          </span>
                          {challenge?.challengerUid && (
                            <>
                              {" "}
                              {t("against")}{" "}
                              <span
                                className="eventChallengeSubmitterName"
                                style={{ color: "#FABB00" }}
                              >
                                {challenge?.challengerUid === user?.uid
                                  ? t("you")
                                  : challenge?.challengerName}
                              </span>
                            </>
                          )}
                        </p>
                        {challenge?.submitterUid === user?.uid &&
                          !challenge?.challengerUid && (
                            <button
                              onClick={() => cancelChallenge(challenge)}
                              className="primaryBtn cancelChallengeBtn"
                              style={{
                                marginTop: "0.5rem",
                                backgroundColor: "#FF0000",
                              }}
                            >
                              {t("cancel").toUpperCase()}
                            </button>
                          )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <p
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    marginTop: "2rem",
                  }}
                >
                  {t("youHaveNoActiveChallengesYet")}
                </p>
              )}
            </div>
          ) : (
            // : activeTab === 'REQUESTS' ?
            //   <div className='adminPageSection'>
            //     {
            //       requestedChallenges?.length > 0 ?
            //         requestedChallenges.map(challenge => {
            //           return (
            //             <div>
            //             </div>
            //           )
            //         })
            //       :
            //         <p style={{color: "#FFFFFF", textAlign: 'center', marginTop: '2rem'}}>
            //           {t('youHaveNoChallengeRequestsYet')}
            //         </p>
            //     }
            //   </div>
            <div className="adminPageSection">
              {closedChallenges?.length > 0 ? (
                closedChallenges.map((challenge) => {
                  console.log(challenge, user?.uid);
                  return (
                    <div style={{ opacity: challenge.isExpired ? 0.5 : 1 }}>
                      <div
                        className="eventChallengeCard"
                        style={{
                          color: "#FFFFFF",
                          cursor: "default",
                          textAlign: "center",
                          boxShadow:
                            challenge?.winnerUid === user?.uid
                              ? "0px 0px 0px 3px #00FF00 inset"
                              : "0px 0px 0px 3px #FF0000 inset",
                        }}
                      >
                        <p>
                          <div className="challengeEventDetails">
                            <p style={{ fontSize: "14px" }}>
                              {challenge.sport} - {challenge.league}
                            </p>
                            <div className="challengeEventTeams">
                              <div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontFamily: "Oswald",
                                  }}
                                >
                                  {t("home").toUpperCase()}
                                </p>
                                <p>{challenge.event.homeTeam.toUpperCase()}</p>
                              </div>
                              <p
                                style={{
                                  marginLeft: "1rem",
                                  marginRight: "1rem",
                                  fontWeight: "bold",
                                  color: "#FABB00",
                                }}
                              >
                                {t("vs").toUpperCase()}
                              </p>
                              <div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontFamily: "Oswald",
                                  }}
                                >
                                  {t("away").toUpperCase()}
                                </p>
                                <p>{challenge.event.awayTeam.toUpperCase()}</p>
                              </div>
                            </div>
                          </div>
                          <span
                            className="eventChallengeSubmitterName"
                            style={{ color: "#FABB00" }}
                          >
                            {t("you")}
                          </span>{" "}
                          {challenge?.winnerUid === user?.uid
                            ? t("won")
                            : t("lost")}{" "}
                          <span className="eventChallengeTickets">
                            {challenge.starCoins}
                          </span>{" "}
                          {t("starCoins")} {t("against")}{" "}
                          <span
                            className="eventChallengeSubmitterName"
                            style={{ color: "#FABB00" }}
                          >
                            {challenge?.submitterUid === user?.uid
                              ? challenge?.challengerName
                              : challenge?.submitterName}
                          </span>
                        </p>
                        {/* TEMPORARY */}
                        {challenge?.winnerUid === user?.uid &&
                          !challenge.isRewardClaimed && (
                            <div className="challengeClaimRewardsContainer">
                              <button
                                onClick={() => claimStarCoins(challenge)}
                                className="challengeClaimStarCoinsBtn"
                              >
                                {t("claimStarCoins")}
                              </button>
                              <button
                                onClick={() => claimTickets(challenge)}
                                className="challengeClaimTicketsBtn"
                              >
                                {t("claimTickets")}
                              </button>
                            </div>
                          )}
                      </div>
                    </div>
                  );
                })
              ) : (
                <p
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    marginTop: "2rem",
                  }}
                >
                  {t("youHaveNoChallengeHistoryYet")}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChallengesPage;
